import type { FC } from 'react';
import { Switch } from 'src/common/components/switch';
import { useCurrentSpace } from 'src/hooks/space';

import { Option } from '../option';
import { SettingProvider } from '../common';
import { useModel } from 'src/common/create-model';
import { isPersonalSpace } from 'src/hooks/space/use-is-pro-space';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export const TemplateRecommendSetting: FC = () => {
  const { t } = useAppTranslation();
  const {
    spaceSettingState: { enableRecommend, setRecommend },
  } = useModel(SettingProvider);
  const currentSpace = useCurrentSpace();
  if (isPersonalSpace(currentSpace.planType)) return null;

  if (__PRIVATE__) return null;
  return (
    <Option
      title={t('components.setting_modal.space_setting.template_recommend.title')}
      description={t('components.setting_modal.space_setting.template_recommend.description')}
      rightPart={<Switch open={enableRecommend} onSwitch={setRecommend} />}
    />
  );
};
